import { isSupabaseConfigured, SUPABASE_ANON_KEY, SUPABASE_URL } from "../config/supabasePublic";

const EDGE_SLUG = "talo-contact";

function functionsUrl() {
  return `${String(SUPABASE_URL).replace(/\/$/, "")}/functions/v1/${EDGE_SLUG}`;
}

function anonHeaders() {
  return {
    "Content-Type": "application/json",
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  };
}

/**
 * @param {{ name: string, email: string, message: string, turnstileToken?: string, company?: string }} payload
 * @returns {Promise<{ ok: true } | { ok: false, error: string }>}
 */
export async function sendContactMessage(payload) {
  if (!isSupabaseConfigured()) {
    return { ok: false, error: "Configuration serveur manquante." };
  }
  try {
    const res = await fetch(functionsUrl(), {
      method: "POST",
      headers: anonHeaders(),
      body: JSON.stringify({
        name: payload.name,
        email: payload.email,
        message: payload.message,
        turnstileToken: payload.turnstileToken ?? "",
        company: payload.company ?? "",
      }),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg =
        (typeof body.error === "string" && body.error) ||
        (res.status === 404
          ? "Service de contact indisponible. Déployez talo-contact."
          : `Erreur ${res.status}`);
      return { ok: false, error: msg };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: String(e?.message ?? e) };
  }
}
